import { Component, Input, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { Product } from '../../models/product.model';
import { AnalyticsUtilsService } from '../../shared/analytics-utils.service';
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';

@Component({
  selector: 'product-legends',
  templateUrl: './product-legends.component.html',
  styleUrls: ['./product-legends.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  animations: [
    trigger('moveStops', [
      state('move', style({
        transform: 'translateX(0)',
      })),
      state('back', style({
        transform: 'translateY(-100%)',
      })),
      transition('* => *', animate('250ms ease-out')),
    ]),
    trigger('moveVoucher', [
      state('move', style({
        transform: 'translateX(0) translateY(0)',
      })),
      state('back', style({
        transform: 'translateX(-100%) translateY(-100%)',
      })),
      transition('* => *', animate('250ms ease-out')),
    ]),
    trigger('moveFree', [
      state('move', style({
        transform: 'translateX(0) translateY(0)',
      })),
      state('back', style({
        transform: 'translateX(-200%) translateY(-100%)',
      })),
      transition('* => *', animate('250ms ease-out')),
    ]),
    trigger('moveSchedule', [
      state('move', style({
        transform: 'translateX(0)',
      })),
      state('back', style({
        transform: 'translateX(-100%)',
      })),
      transition('* => *', animate('250ms ease-out')),
    ]),
    trigger('moveLanguage', [
      state('move', style({
        transform: 'translateX(0)',
      })),
      state('back', style({
        transform: 'translateX(-200%)',
      })),
      transition('* => *', animate('250ms ease-out')),
    ]),
    trigger('showText', [
      state('move', style({
        transform: 'translateY(0)',
        color: '#fafafa',
        opacity: 0,
        display: 'none',
        height: 0
      })),
      state('back', style({
        transform: 'translateY(-140px)',
        color: '#8F8F8F',
        opacity: 1,
        maxWidth:'100%',
        height: '100%'
      })),
      transition('* => *', animate('250ms ease-out')),
    ]),
    trigger('showTextBasic', [
      state('move', style({
        transform: 'translateY(0)',
        color: '#fafafa',
        opacity: 0,
        display: 'none',
        height: 0
      })),
      state('back', style({
        transform: 'translateY(-90px)',
        color: '#8F8F8F',
        opacity: 1,
        maxWidth:'100%',
        height: '100%'
      })),
      transition('* => *', animate('250ms ease-out')),
    ]),
    trigger('iconLeft', [
      state('transition', style({
        transform: 'translateX(-300%)',
        opacity: 0
      })),
      state('normal', style({
        transform: 'translateX(0)',
        opacity: 1
      })),
      transition('* => *', animate('250ms ease-out')),
    ]),
    trigger('iconRight', [
      state('transition', style({
        transform: 'translateX(100%)',
        opacity: 0
      })),
      state('normal', style({
        transform: 'translateX(0)',
        opacity: 1
      })),
      transition('* => *', animate('250ms ease-out')),
    ]),
    trigger('iconMiddle', [
      state('left', style({
        transform: 'translateX(-200%)',
        opacity: 0
      })),
      state('right', style({
        transform: 'translateX(200%)',
        opacity: 0
      })),
      state('normal', style({
        transform: 'translateX(0)',
        opacity: 1
      })),
      transition('* => *', animate('250ms ease-out')),
    ]),
    trigger('icon2Middle', [
      state('left', style({
        transform: 'translateX(-200%)',
        opacity: 0
      })),
      state('right', style({
        transform: 'translateX(200%)',
        opacity: 0
      })),
      state('normal', style({
        transform: 'translateX(0)',
        opacity: 1
      })),
      transition('* => *', animate('250ms ease-out')),
    ]),
    trigger('moveMobileSchedule', [
      state('move', style({
        transform: 'translateX(0)',
      })),
      state('back', style({
        transform: 'translateX(-100%)',
      })),
      transition('* => *', animate('250ms ease-out')),
    ]),
    trigger('moveMobileLanguages', [
      state('move', style({
        transform: 'translateX(0) translateY(0)',
      })),
      state('back', style({
        transform: 'translateX(-100%) translateY(-100%)',
      })),
      transition('* => *', animate('250ms ease-out')),
    ]),
    trigger('moveMobileFree', [
      state('move', style({
        transform: 'translateX(0) translateY(0)',
      })),
      state('back', style({
        transform: 'translateX(-100%) translateY(-200%)',
      })),
      transition('* => *', animate('250ms ease-out')),
    ]),
    trigger('moveMobileStops', [
      state('move', style({
        transform: 'translateY(0)',
      })),
      state('back', style({
        transform: 'translateY(-100%)',
      })),
      transition('* => *', animate('250ms ease-out')),
    ]),
    trigger('moveMobileVoucher', [
      state('move', style({
        transform: 'translateY(0)',
      })),
      state('back', style({
        transform: 'translateY(-200%)',
      })),
      transition('* => *', animate('250ms ease-out')),
    ]),
    trigger('moveMobileOnlyRoutes', [
      state('move', style({
        transform: 'translateX(0)',
        opacity: 1
      })),
      state('back', style({
        transform: 'translateX(-100%)',
        opacity: 0
      })),
      transition('* => *', animate('250ms ease-out')),
    ]),
    trigger('moveMobileOnlyStops', [
      state('move', style({
        transform: 'translateX(0)',
        opacity: 1
      })),
      state('back', style({
        transform: 'translateX(-100%)',
        opacity: 0
      })),
      transition('* => *', animate('250ms ease-out')),
    ]),
    trigger('moveMobileOnlyVoucher', [
      state('move', style({
        transform: 'translateX(0)',
        opacity: 1
      })),
      state('back', style({
        transform: 'translateX(-100%)',
        opacity: 0
      })),
      transition('* => *', animate('250ms ease-out')),
    ]),
    trigger('moveMobileOnlySchedule', [
      state('move', style({
        transform: 'translateX(0)',
        opacity: 1
      })),
      state('back', style({
        transform: 'translateX(100%)',
        opacity: 0
      })),
      transition('* => *', animate('250ms ease-out')),
    ]),
    trigger('moveMobileOnlyLanguages', [
      state('move', style({
        transform: 'translateX(0)',
        opacity: 1
      })),
      state('back', style({
        transform: 'translateX(150%)',
        opacity: 0
      })),
      transition('* => *', animate('250ms ease-out')),
    ]),
    trigger('moveMobileOnlyFree', [
      state('move', style({
        transform: 'translateX(0)',
        opacity: 1
      })),
      state('back', style({
        transform: 'translateX(150%)',
        opacity: 0
      })),
      transition('* => *', animate('250ms ease-out')),
    ]),
  ]
})
export class ProductLegendsComponent implements OnChanges {
  constructor(private analytics: AnalyticsUtilsService){ }
    @Input() product:Product;
    public time:number;
    public nameCont:string = "";

    /** TEXT ANIMATION CONTROL **/
    public animationText:boolean = false;

    /** WEB PAGE **/
    public animationStops:boolean = false;
    public animationLanguage:boolean = false;
    public animationSchedule:boolean = false;
    public animationFree:boolean = false;
    public animationVoucher:boolean = false;
    public stateMiddle:number = 0;
    public state2Middle:number = 0;

    /** MIDDLE ICONS HELPERS **/
    public animationLeftDissapear:boolean = false;
    public animationLeft2Dissapear:boolean = false;
    public animationLeft3Dissapear:boolean = false;
    public animationRightDissapear:boolean = false;
    public animationRight2Dissapear:boolean = false;
    public animationRight3Dissapear:boolean = false;

    /** MOBILE **/
    public animationOnlyRoutes:boolean = false;
    public animationOnlyStops:boolean = false;
    public animationOnlySchedule:boolean = false;
    public animationOnlyLanguages:boolean = false;
    public animationOnlyFree:boolean = false;
    public animationOnlyVoucher:boolean = false;

    public listOfRoutes:any[] = [];
    public mainStops:any;

    public ngOnChanges(changes:SimpleChanges){
      if(this.product != null && this.product.hopOnHopOff){
        let init = this.product.bestRoute.bestScheduleInit;
        let end = this.product.bestRoute.bestScheduleEnd;
        this.product.bestRoute.bestScheduleInit = new Date(`01/01/1970 ${init}`);
        this.product.bestRoute.bestScheduleEnd = new Date(`01/01/1970 ${end}`);
        this.createRoutes(this.product);
        this.createMainStops(this.product);
      }else if(this.product != null && !this.product.hopOnHopOff && this.product.bestRoute.duration != null){
        this.time = this.product.bestRoute.duration; // Duration always arrives in 'minutes' 
        let type:string = this.product.bestRoute.durationType.toUpperCase();
        this.product.bestRoute.durationType = type;
        if(type === "HOUR"){
          this.time /= 60; 
        }else if(type === "DAY"){
          this.time /= 60*24; 
        }
      }
    }
    
    get stateText() {
      return this.animationText ? 'back' : 'move';
    }

    get stateStops() {
      return this.animationStops ? 'back' : 'move';
    }

    get stateVoucher() {
      return this.animationVoucher ? 'back' : 'move';
    }

    get stateLanguage() {
      return this.animationLanguage ? 'back' : 'move';
    }

    get stateFree() {
      return this.animationFree ? 'back' : 'move';
    }

    get stateSchedule() {
      return this.animationSchedule ? 'back' : 'move';
    }

    get stateMiddleDissapear() {
      if(this.stateMiddle == 1) {
        return 'left';
      } else if(this.stateMiddle == 2){
        return 'right';
      } else {
        return 'normal';
      }
    }

    get stateMiddle2Dissapear() {
      if(this.state2Middle == 1) {
        return 'left';
      } else if(this.state2Middle == 2){
        return 'right';
      } else {
        return 'normal';
      }
    }

    get stateLeftDissapear() {
      return this.animationLeftDissapear ? 'transition' : 'normal';
    }

    get stateLeft2Dissapear() {
      return this.animationLeft2Dissapear ? 'transition' : 'normal';
    }

    get stateLeft3Dissapear() {
      return this.animationLeft3Dissapear ? 'transition' : 'normal';
    }

    get stateRightDissapear() {
      return this.animationRightDissapear ? 'transition' : 'normal';
    }

    get stateRight2Dissapear() {
      return this.animationRight2Dissapear ? 'transition' : 'normal';
    }

    get stateRight3Dissapear() {
      return this.animationRight3Dissapear ? 'transition' : 'normal';
    }

    get stateOnlyRoutes() {
      return this.animationOnlyRoutes ? 'back' : 'move';
    }

    get stateOnlyStops(){
      return this.animationOnlyStops ? 'back' : 'move';
    }

    get stateOnlyVoucher(){
      return this.animationOnlyVoucher ? 'back' : 'move';
    }

    get stateOnlySchedule() {
      return this.animationOnlySchedule ? 'back' : 'move';
    }

    get stateOnlyLanguages() {
      return this.animationOnlyLanguages ? 'back' : 'move';

    }

    get stateOnlyFree() {
      return this.animationOnlyFree ? 'back' : 'move';

    }
    
    startAnimation(nameID) {
      this.clickOnLegendIcon();
      if(nameID == 'languages'){
        this.animationLanguage = !this.animationLanguage;
        this.animationLeftDissapear = !this.animationLeftDissapear;
        this.animationRight2Dissapear = !this.animationRight2Dissapear;
        this.stateMiddle == 0 ? this.stateMiddle = 1 : this.stateMiddle = 0;
        this.state2Middle == 0 ? this.state2Middle = 1 : this.state2Middle = 0;
        this.nameCont = nameID;
        this.animationText = !this.animationText;
      } else if(nameID == 'routes'){
        this.animationRightDissapear = !this.animationRightDissapear;
        this.animationLeft2Dissapear = !this.animationLeft2Dissapear;
        this.stateMiddle == 0 ? this.stateMiddle = 1 : this.stateMiddle = 0;
        this.state2Middle == 0 ? this.state2Middle = 2 : this.state2Middle = 0;
        this.nameCont = nameID;
        this.animationText = !this.animationText;
      } else if(nameID == "schedule") {
        this.animationSchedule = !this.animationSchedule;
        this.animationLeftDissapear = !this.animationLeftDissapear;
        this.animationRightDissapear = !this.animationRightDissapear;
        this.stateMiddle != 1 ? this.stateMiddle = 1 : this.stateMiddle = 0;
        this.nameCont = 'routes';
        this.animationText = !this.animationText;
      } else if (nameID == 'stops'){
        this.animationStops = !this.animationStops;
        this.animationLeft3Dissapear = !this.animationLeft3Dissapear;
        this.animationRightDissapear = !this.animationRightDissapear;
        this.stateMiddle == 0 ? this.stateMiddle = 1 : this.stateMiddle = 0;
        this.state2Middle == 0 ? this.state2Middle = 2 : this.state2Middle = 0;
        this.nameCont = nameID;
        this.animationText = !this.animationText;
      } else if (nameID == 'free'){
        this.animationFree = !this.animationFree;
        this.animationRight3Dissapear = !this.animationRight3Dissapear;
        this.animationLeftDissapear = !this.animationLeftDissapear;
        this.stateMiddle == 0 ? this.stateMiddle = 1 : this.stateMiddle = 0;
        this.state2Middle == 0 ? this.state2Middle = 1 : this.state2Middle = 0;
        this.nameCont = nameID;
        this.animationText = !this.animationText;
      } else if (nameID == 'voucher'){
        this.animationVoucher = !this.animationVoucher;
        this.animationLeftDissapear = !this.animationLeftDissapear;
        this.animationRightDissapear = !this.animationRightDissapear;
        this.state2Middle == 0 ? this.state2Middle = 1 : this.state2Middle = 0;
        this.nameCont = nameID;
        this.animationText = !this.animationText;

      }
    }

    startAnimationMobile(nameID){
      this.clickOnLegendIcon();
      if(nameID == 'schedule') {
        this.animationSchedule = !this.animationSchedule;
        this.animationOnlyLanguages = !this.animationOnlyLanguages;
        this.animationOnlyFree = !this.animationOnlyFree;
        this.animationLeftDissapear = !this.animationLeftDissapear;
        this.nameCont = 'route';
        this.animationText = !this.animationText;
      } else if (nameID == 'route'){
        this.animationOnlyStops = !this.animationOnlyStops;
        this.animationOnlyVoucher = !this.animationOnlyVoucher;
        this.animationRightDissapear = !this.animationRightDissapear;
        this.nameCont = nameID;
        this.animationText = !this.animationText;
      } else if (nameID == 'languages'){
        this.animationLanguage = !this.animationLanguage;
        this.animationOnlySchedule = !this.animationOnlySchedule;
        this.animationOnlyFree = !this.animationOnlyFree;
        this.animationLeftDissapear = !this.animationLeftDissapear;
        this.nameCont = nameID;
        this.animationText = !this.animationText;
      } else if (nameID == 'voucher'){
        this.animationVoucher = !this.animationVoucher;
        this.animationOnlyStops = !this.animationOnlyStops;
        this.animationOnlyRoutes = !this.animationOnlyRoutes;
        this.animationRightDissapear = !this.animationRightDissapear;
        this.nameCont = nameID;
        this.animationText = !this.animationText;
      } else if (nameID == 'free'){
        this.animationFree = !this.animationFree;
        this.animationOnlySchedule = !this.animationOnlySchedule;
        this.animationOnlyLanguages = !this.animationOnlyLanguages;
        this.animationLeftDissapear = !this.animationLeftDissapear;
        this.nameCont = nameID;
        this.animationText = !this.animationText;
      } else {
        this.animationStops = !this.animationStops;
        this.animationOnlyVoucher = !this.animationOnlyVoucher;
        this.animationOnlyRoutes = !this.animationOnlyRoutes;
        this.animationRightDissapear = !this.animationRightDissapear;
        this.nameCont = nameID;
        this.animationText = !this.animationText;
      }
    }

    clickOnLegendIcon() {
      // this.analytics.click_on_legendIcon();
    }

    private createRoutes(product){
      this.listOfRoutes =  [];
      product.routes.map(route => {
        this.listOfRoutes.push(route);
      });
    }

    private createMainStops(product){
      this.mainStops = [];
      let cache = {}; 
      if (product.routes != null) {
        product.routes.map(route => {
          route.stoppingPlaces.map(stop => {
            if(stop.image && !cache[stop.id]){
              let _main = {};
              _main['routeName'] = route.name;
              _main['number'] = stop.number;
              _main['name'] = stop.name;
              _main['imageURL'] = stop.image;
              _main['placeOrder'] = stop.placeOrder;
              this.mainStops.push(_main);
              cache[stop.id] = true;
            }
          })
        })
      }
    }
}